import { gql, useMutation } from "@apollo/client";

import { CreateCollectionInput } from "../../../generated/gql/graphql";

const CREATE_COLLECTION = gql`
  mutation CreateCollection($input: CreateCollectionInput!) {
    createCollection(input: $input) {
      id
      status
      sort
      name
      image
      userId
      sharedUserIds
      dateCreated
      dateUpdated
      createdBy
    }
  }
`;

type CreateCollectionApi = {
  createCollection(input: CreateCollectionInput): Promise<unknown>;
};

export default function useCreateCollection(): CreateCollectionApi {
  const [createCollectionMut] =
    useMutation<CreateCollectionInput>(CREATE_COLLECTION);

  async function createCollection(
    input: CreateCollectionInput
  ): Promise<unknown> {
    return await createCollectionMut({
      context: {
        headers: {
          "apollo-require-preflight": true,
        },
      },
      variables: {
        input,
      },
    });
  }

  return {
    createCollection,
  };
}
